module.exports = __webpack_public_path__ + "img/news03.181254a.png";